export const Domain = "pdbidrdemo.com.au";
export const DefaultPdClientType = "cognito";
export const EnvironmentName = "Demo";
